import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductService } from "../../shared/services/product.service";
import { EcomProd, Product } from "../../shared/classes/product";

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss']
})
export class WishlistComponent implements OnInit {

  public products: Product[] = [];

  public ecomproducts: EcomProd[] = [];

  @Input() onHowerChangeImage: boolean = false;
  public ImageSrc: string

  constructor(private router: Router,
    public productService: ProductService) {
    // this.productService.wishlistItems.subscribe(response => this.ecomproducts = response);
  }

  Fprod: any = [];

  ngOnInit(): void {

    if (JSON.parse(localStorage.getItem("fav"))) {
      this.Fprod = JSON.parse(localStorage.getItem("fav"));
    }
    this.ecomproducts = this.Fprod;
    // console.log("this.ecomproducts",this.ecomproducts)
    // console.log("this.Fprod",this.Fprod)

  }

  async addToCart(product: any) {
    const status = await this.productService.addToCart(product);
    if (status) {
      this.router.navigate(['/shop/cart']);
      this.removeItem(product);
    }
  }

  removeItem(product: any) {
    this.productService.removeWishlistItem(product);
  }

  removefav(item) {
    // console.log("Remo item:::",item)
    this.ecomproducts.splice(item, 1)
    localStorage.setItem("fav", JSON.stringify(this.ecomproducts))
  }



}


